var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69141 19.9905C4.69139 21.9936 5.08593 23.9772 5.85249 25.8279C6.61906 27.6786 7.74264 29.3601 9.15908 30.7766C10.5755 32.1931 12.2571 33.3167 14.1078 34.0832C15.9585 34.8498 17.942 35.2444 19.9452 35.2444C21.9483 35.2444 23.9319 34.8498 25.7826 34.0832C27.6333 33.3167 29.3148 32.1931 30.7313 30.7766C32.1477 29.3601 33.2713 27.6786 34.0379 25.8279C34.8044 23.9772 35.199 21.9936 35.1989 19.9905C35.199 17.9873 34.8044 16.0038 34.0379 14.1531C33.2713 12.3024 32.1477 10.6208 30.7313 9.20434C29.3148 7.78788 27.6333 6.66428 25.7826 5.8977C23.9319 5.13112 21.9483 4.73656 19.9452 4.73656C17.942 4.73656 15.9585 5.13112 14.1078 5.8977C12.2571 6.66428 10.5755 7.78788 9.15908 9.20434C7.74264 10.6208 6.61906 12.3024 5.85249 14.1531C5.08593 16.0038 4.69139 17.9873 4.69141 19.9905Z",
    fill: "#2469EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3256 20.6769C26.0817 20.6769 25.8378 20.5839 25.6519 20.3972L19.9452 14.6953L14.2385 20.3972C13.8659 20.7698 13.2629 20.7698 12.8903 20.3972C12.5177 20.0246 12.5177 19.4208 12.8903 19.049L19.2707 12.6726C19.6433 12.3 20.2463 12.3 20.6189 12.6726L26.9993 19.049C27.3719 19.4208 27.3719 20.0246 26.9993 20.3972C26.9111 20.4861 26.8061 20.5566 26.6905 20.6046C26.5748 20.6526 26.4508 20.6772 26.3256 20.6769Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9444 27.588C19.4177 27.588 18.991 27.1605 18.991 26.6346V13.3471C18.991 12.8204 19.4185 12.3938 19.9444 12.3938C20.4711 12.3938 20.8977 12.8212 20.8977 13.3471V26.6346C20.8977 27.1605 20.4711 27.588 19.9444 27.588Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadModel);
export default __webpack_public_path__ + "static/media/upload-model.e70a17dbe5e6e21fcb89f3f6550dca34.svg";
export { ForwardRef as ReactComponent };